import React from 'react';
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box,
  Flex,
  Wrap,
  WrapItem,
  Tag,
  Text,
} from '@chakra-ui/react';

/**
 * Desplegable informativo con las materias reales (payment.subjects) y los
 * conceptos (payment.other_payments) del pago. NO es interactivo: solo sirve
 * como referencia para que Cindy entienda qué venía asignado desde el flujo
 * legacy "Matricular Materias".
 *
 * Estilo alineado 1:1 al mockup ModalSimple:
 *   "> Materias reales asociadas al pago [N]  solo referencia · se maneja en Matricular Materias"
 */
export default function SubjectsInfoAccordion({ subjects, otherPayments }) {
  const hasSubjects = Array.isArray(subjects) && subjects.length > 0;
  const hasOthers = Array.isArray(otherPayments) && otherPayments.length > 0;
  if (!hasSubjects && !hasOthers) {
    return (
      <Text fontSize="xs" color="gray.500" fontStyle="italic">
        Este pago no trae subjects ni conceptos registrados.
      </Text>
    );
  }
  const badgeCount = (hasSubjects ? subjects.length : 0) + (hasOthers ? otherPayments.length : 0);

  return (
    <Accordion
      allowToggle
      borderWidth="1px"
      borderColor="gray.200"
      bg="#FAFAFC"
      borderRadius="6px"
    >
      <AccordionItem border="none">
        {({ isExpanded }) => (
          <>
            <AccordionButton
              px={3}
              py={2}
              _hover={{ bg: 'transparent' }}
              _focus={{ boxShadow: 'none' }}
            >
              <Flex align="center" gap={2} flex="1" textAlign="left">
                <AccordionIcon color="gray.500" />
                <Text fontSize="12px" color="gray.600" fontWeight="500">
                  Materias reales asociadas al pago
                </Text>
                <Box
                  bg="gray.100"
                  color="gray.700"
                  fontSize="10px"
                  fontWeight="700"
                  px={1.5}
                  py={0.25}
                  borderRadius="3px"
                  lineHeight="1.4"
                >
                  {badgeCount}
                </Box>
                <Text fontSize="11px" color="gray.400" fontStyle="italic" fontWeight="400">
                  solo referencia · se maneja en "Matricular Materias"
                </Text>
              </Flex>
            </AccordionButton>
            <AccordionPanel px={3} pt={2} pb={3}>
              {hasSubjects && (
                <Box mb={hasOthers ? 3 : 0}>
                  <Wrap spacing={1.5}>
                    {subjects.map((s) => (
                      <WrapItem key={s.id}>
                        <Tag
                          size="sm"
                          bg="white"
                          borderWidth="1px"
                          borderColor="gray.200"
                          color="gray.700"
                          fontSize="11px"
                          borderRadius="999px"
                        >
                          {s.name}
                        </Tag>
                      </WrapItem>
                    ))}
                  </Wrap>
                  <Text fontSize="10px" color="gray.400" mt={1.5}>
                    No influyen en las cantidades del reporte financiero. Estas materias se
                    manejan desde "Matricular Materias" y activan subject-enrollments del
                    alumno.
                  </Text>
                </Box>
              )}
              {hasOthers && (
                <Box>
                  <Text fontSize="10px" color="gray.500" fontWeight="600" mb={1} letterSpacing="0.05em">
                    CONCEPTOS DEL PAGO
                  </Text>
                  <Wrap spacing={1.5}>
                    {otherPayments.map((o) => (
                      <WrapItem key={o.id}>
                        <Tag size="sm" variant="subtle" colorScheme="blue" fontSize="11px">
                          {o.name}
                        </Tag>
                      </WrapItem>
                    ))}
                  </Wrap>
                </Box>
              )}
            </AccordionPanel>
          </>
        )}
      </AccordionItem>
    </Accordion>
  );
}
